<template>
  <section class="sidebar-nav-section">
    <h2 class="sidebar-nav-section__label">
      {{ section.label }}
    </h2>
    <ul class="sidebar-nav-section__list">
      <li
        v-for="item in section.items"
        :key="item.key"
        class="sidebar-nav-section__item"
      >
        <component
          :is="item.isDisabled ? 'span' : 'router-link'"
          :to="item.isDisabled ? undefined : navTarget(item)"
          :class="[
            ...linkClass(item, activeStates[item.key]),
            { 'sidebar-nav-link--has-rail-badge': isRailMode && item.badge }
          ]"
          :data-nav-path="item.path"
          :aria-current="activeStates[item.key] ? 'page' : undefined"
          :aria-disabled="item.isDisabled ? 'true' : undefined"
          :aria-label="item.ariaLabel || item.label"
          v-tooltip.right="tooltipLabel(item)"
          @click="handleClick(item, $event)"
        >
          <span
            class="sidebar-nav-link__icon"
            :class="{
              'sidebar-nav-link__icon--has-alert':
                item.showAlertDot && !(isRailMode && item.badge)
            }"
            aria-hidden="true"
          >
            <i :class="['pi', 'pi-fw', item.icon]" />
          </span>
          <span
            v-if="isRailMode && item.badge"
            class="sidebar-nav-link__rail-badge"
            aria-hidden="true"
          >
            {{ formatBadge(item.badge) }}
          </span>
          <span class="sidebar-nav-link__text">
            {{ item.label }}
          </span>
          <span
            v-if="item.statusBadge"
            class="sidebar-nav-badge sidebar-nav-badge--status"
          >
            {{ item.statusBadge }}
          </span>
          <span
            v-else-if="item.badge"
            class="sidebar-nav-badge sidebar-nav-badge--count"
          >
            {{ formatBadge(item.badge) }}
          </span>
        </component>
      </li>
    </ul>
  </section>
</template>

<script>
import { isRouteActive } from '@/features/drivers-workspace/utils/shellNavActive';

export default {
  name: 'SidebarNavSection',
  props: {
    section: {
      type: Object,
      required: true
    },
    isRailMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['navigate'],
  computed: {
    currentUserId() {
      return this.$store.state.users?.user?.id ?? null;
    },
    activeStates() {
      const route = this.$route;
      const states = {};

      for (const item of this.section.items || []) {
        states[item.key] = isRouteActive(item.path, route.path, {
          routeName: item.routeName,
          activeRouteName: route.name,
          relatedRouteNames: item.relatedRouteNames,
          routeParams: route.params,
          currentUserId: this.currentUserId,
          navKey: item.key
        });
      }

      return states;
    }
  },
  methods: {
    navTarget(item) {
      if (item.key === 'my-profile') {
        return { name: 'my-profile' };
      }
      return item.path;
    },
    linkClass(item, isActive) {
      return [
        'sidebar-nav-link',
        {
          'sidebar-nav-link--active': isActive,
          'sidebar-nav-link--disabled': item.isDisabled
        }
      ];
    },
    tooltipLabel(item) {
      if (!this.isRailMode) return null;
      return item.railTooltip || item.label;
    },
    formatBadge(value) {
      const count = Number(value);
      if (!Number.isFinite(count)) return String(value);
      return count > 99 ? '99+' : String(count);
    },
    handleClick(item, event) {
      if (item.isDisabled) {
        event?.preventDefault();
        return;
      }
      event?.preventDefault();
      this.$emit('navigate', item, event);
    }
  }
};
</script>
